import React from "react";
import DataTablePage, { StatusBadge, formatDate } from "./DataTablePage";
import { Badge } from "../components/ui/badge";

const sevMap = {
  critical: { v: "critical", label: "Critical" },
  high: { v: "warning", label: "High" },
  medium: { v: "warning", label: "Medium" },
  low: { v: "success", label: "Low" },
};
const statusMap = {
  open: { v: "critical", label: "Open" },
  in_review: { v: "info", label: "In review" },
  resolved: { v: "success", label: "Resolved" },
};

export default function FindingsPage() {
  return (
    <DataTablePage
      title="Findings"
      description="Audit findings and observations awaiting remediation."
      endpoint="/findings"
      testIdPrefix="findings"
      searchKeys={["title", "audit_ref"]}
      filters={[
        {
          key: "severity",
          label: "All severities",
          options: [
            { label: "Critical", value: "critical" },
            { label: "High", value: "high" },
            { label: "Medium", value: "medium" },
            { label: "Low", value: "low" },
          ],
        },
        {
          key: "status",
          label: "All statuses",
          options: [
            { label: "Open", value: "open" },
            { label: "In review", value: "in_review" },
            { label: "Resolved", value: "resolved" },
          ],
        },
      ]}
      columns={[
        { key: "title", label: "Finding" },
        { key: "severity", label: "Severity", render: (r) => <StatusBadge value={r.severity} map={sevMap} /> },
        { key: "audit_ref", label: "Audit", render: (r) => <Badge variant="primary">{r.audit_ref}</Badge> },
        { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} map={statusMap} /> },
        { key: "created_at", label: "Raised", render: (r) => formatDate(r.created_at) },
      ]}
    />
  );
}
